import { canonicalAction } from "./helpers";

/**
 * ActionChip — pixel-perfect réplica de los chips circulares de PPPoker.
 *
 * Localización (português/español PPPoker):
 *   - F (Fold)        → gris
 *   - C (Call/Check)  → verde   (también "Pagar"/"Pasar")
 *   - B (Bet postflop)→ naranja
 *   - P (Raise/Postura preflop) → naranja
 *   - A (All-in)      → rojo glow
 *   - S (Show/Mostrar)→ azul
 *   - SB / BB         → púrpura (forced blinds)
 */
const ACTION_STYLE = {
  fold:    { letter: "F", cls: "bg-[#767b86] text-white" },
  // ⭐ CHECK y CALL en PPPoker nativo son ambos verdes pero distintos:
  // CHECK = verde apagado/grisáceo (no hay flujo de dinero)
  // CALL  = verde brillante (sí hay flujo de dinero)
  check:   { letter: "C", cls: "bg-[#5d8d76] text-white" },
  call:    { letter: "C", cls: "bg-[#1aa582] text-white" },
  bet:     { letter: "B", cls: "bg-[#e1a029] text-white" },
  raise:   { letter: "P", cls: "bg-[#e1a029] text-white" },
  reraise: { letter: "P", cls: "bg-[#e1a029] text-white" },
  allin:   { letter: "A", cls: "bg-[#d94d5d] text-white shadow-[0_0_8px_rgba(217,77,93,0.55)]" },
  "all-in":{ letter: "A", cls: "bg-[#d94d5d] text-white shadow-[0_0_8px_rgba(217,77,93,0.55)]" },
  sb:      { letter: "SB", cls: "bg-[#4c4778] text-[#e9e7ff] text-[9px]" },
  bb:      { letter: "BB", cls: "bg-[#4c4778] text-[#e9e7ff] text-[9px]" },
  ante:    { letter: "A", cls: "bg-[#767b86] text-white" },
  show:    { letter: "S", cls: "bg-[#3aa3d7] text-white" },
  muck:    { letter: "M", cls: "bg-[#767b86] text-white" },
};

export function ActionChip({ action, className = "" }) {
  const key = canonicalAction(action);
  const style = ACTION_STYLE[key] || ACTION_STYLE.fold;
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full text-[12px] font-extrabold tabular-nums leading-none shadow-[inset_0_-2px_0_rgba(0,0,0,0.18)] ${style.cls} ${className}`}
      style={{ width: 26, height: 26 }}
      title={key}
      data-testid={`action-chip-${key}`}
    >
      {style.letter}
    </span>
  );
}
